import { usePathname, useRouter } from "next/navigation";
import { smoothScrollToElement } from "../utils/scrollUtils";

export const useScrollToSection = (onAfterScroll?: () => void) => {
  const pathname = usePathname();
  const router = useRouter();

  const scrollToSection = (sectionId: string) => {
    const isHomePage = pathname === "/";

    if (isHomePage) {
      // If already on home page, scroll to section
      smoothScrollToElement(sectionId);
    } else {
      // If on another page, navigate to home page with hash
      router.push(`/#${sectionId}`);
    }

    // Call optional callback (e.g., to close mobile menu)
    onAfterScroll?.();
  };

  return scrollToSection;
};
